import axios from "axios";

class SocialMediaSwitch {
    constructor() {
        this.switch = "twitter";
        this.btns = document.querySelectorAll(".jsSocialSwitch");
        this.smCard = document.querySelector("#smCardDesktop");
        this.pageAv = null;
        this.pageAvUrl = '';

        this.events();
    }

    events() {
        if (this.btns) {
            this.btns.forEach((el) => {
                el.addEventListener("click", (e) => {
                    this.getProperContent(e.currentTarget.dataset.social);
                });
            });
        }

        // window.fbAsyncInit = () => {
        //     FB.init({
        //         appId: "623065112079926",
        //         autoLogAppEvents: true,
        //         xfbml: true,
        //         version: "v13.0",
        //     });

        //     const res = {};

        //     FB.api(
        //         // eslint-disable-next-line no-undef
        //         "/1120521227993242/picture",
        //         "GET",
        //         {
        //             redirect: false,
        //         },
        //         (response) => {
        //             self.pageAv = document.querySelectorAll(
        //                 ".archives-social__user-av"
        //             );

        //             self.pageAv.forEach((el) => {
        //                 el.src = response.data.url;
        //             });
        //         }
        //     );
        // };



    }

    getProperContent(smType) {
        this.switch = smType;

        const data = new FormData();

        data.append("action", "socialMediaSwitch");
        data.append("sm_type", this.switch);

        axios
            .post(ajax.ajax_url, data)
            .then((res) => {

                    if (this.smCard) {
                        this.smCard.innerHTML = JSON.parse(res.data.data)
                    }

                this.getFbAv();

            })
            .catch((err) => {

            });
    }

    getFbAv(){
        FB.api("/1120521227993242/picture", "GET",
            {
                redirect: false
            },
            (response) => {
                self.pageAv = document.querySelectorAll(".archives-social__user-av")
                self.pageAv.forEach((el) => {
                    el.src = response.data.url;

                });
            }
        );
    }
}

export default SocialMediaSwitch;